<template>
  <div class="search-main">
    <form action="" class="search-box-form" aria-label="Search products">
      <label class="search-box-shop">
        <input type="search" class="desktop-only" placeholder="Search Products..." v-model="searchTextModel">
        <input type="text" class="global-search mobile-only" @input="mobileSearchShop"
               placeholder="Search Products..." v-model="searchTextModel">
      </label>
      <button class="btn-search" @click.prevent="searchShop">
        <i class="fa fa-search" aria-hidden="true"></i>
      </button>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: 'SearchCoatingsProducts',

  computed: {
    ...mapGetters([
      'searchText'
    ]),
    searchTextModel: {
      get() { return this.searchText },
      set(value) { this.setSearchText(value) }
    }
  },

  methods: {
    ...mapMutations([
      'setSearchText'
    ]),
    ...mapActions([
      'mobileSearchShop',
      'searchShop'
    ])
  }
}
</script>

<style lang="scss" scoped>
  .search-main {
    margin-top: 60px !important;
  }
</style>
